<template>
  <img :src="src" :alt="alt" :title="title">
</template>

<script>

export default {
  name: 'asset',
  props: {
    name: {
      type: String,
    },
    alt: {
      type: String,
    },
    title: {
      type: String,
    },
    version: {
      type: String,
      default: 'v2',
    },
    link: {
      type: String,
    },
  },
  computed: {
    src() {
      if (this.link) return this.link;

      if (this.version) {
        return `https://cdn.parcelex.com.br/assets/${this.version}/${this.name}`;
      }
      return `https://cdn.parcelex.com.br/assets/${this.name}`;
    },
  },
};
</script>
